import {API, Setup} from '../../Services';

export async function changeCreditorStatus_api(invoiceId){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.put(`/merchant_admin/${merchantId}/order-picker/rollback-invoices/${invoiceId}`,{
        state:"success_to_pay"
    },{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}
